import React from "react";
import ContractorUserListItem from "../../components/contractorUser/ContractorUserList/ContractorUserListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const ContractorUserListPage = ()  => {

    useTitle(t`List Contractor User`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <ContractorUserListItem showAdd={true} {...query} />
        </Box>
    )
}

export default ContractorUserListPage;
